import { axiosInstance } from '@configs/axios/axiosInstance';

import type { UpdateSelectedOrganizationRequest } from './updateSelectedOrganization.types';

/**
 * Update selected organization
 * Endpoint: PUT /users/selected-organization
 * Returns: 202 Accepted (async processing, no response body)
 */
export async function updateSelectedOrganization(
  payload: UpdateSelectedOrganizationRequest
): Promise<void> {
  await axiosInstance.put('/users/selected-organization', payload);
}
